<template>
    <v-sheet>
        <v-row justify="center" class="row--large">
            <v-col cols="12" sm="6" md="auto">
                <v-card outlined rounded="lg" class="join-gate-box">
                    <div class="w-100 pa-20 pa-md-30 pa-lg-60 join-gate-box__inner">
                        <div class="join-gate-box__icon mb-16 mb-lg-24">
                            <i class="icon icon-user"></i>
                        </div>
                        <h5 class="tit tit--sm mb-4 mb-lg-8">개인회원</h5>
                        <p class="page-text mb-18 mb-lg-32">
                            개인회원가입 관련 한 줄 문구가 입력됩니다.
                        </p>
                        <v-btn @click="$emit('input', USER_TYPES.PERSON.value)" large block color="primary">개인회원가입</v-btn>
                    </div>
                </v-card>
                <!-- <div class="join-gate-box join-gate-box--personal">
                    <div class="join-gate-box__inner">
                        <h2>개인회원</h2>
                        <i class="icon icon-chair"></i>
                        <v-btn color="primary" @click="$emit('input', USER_TYPES.PERSON.value)"> 가입하기 </v-btn>
                    </div>
                </div> -->
            </v-col>
            <v-col cols="12" sm="6" md="auto">
                <v-card outlined rounded="lg" class="join-gate-box">
                    <div class="w-100 pa-20 pa-md-30 pa-lg-60 join-gate-box__inner">
                        <div class="join-gate-box__icon mb-16 mb-lg-24">
                            <i class="icon icon-company"></i>
                        </div>
                        <h5 class="tit tit--sm mb-4 mb-lg-8">기업회원</h5>
                        <p class="page-text mb-18 mb-lg-32">
                            기업회원가입 관련 한 줄 문구가 입력됩니다.
                        </p>
                        <v-btn @click="$emit('input', USER_TYPES.COMPANY.value)" large block color="secondary">기업회원가입</v-btn>
                    </div>
                </v-card>
                <!-- <div class="join-gate-box join-gate-box--business">
                    <div class="join-gate-box__inner">
                        <h2>기업회원</h2>
                        <i class="icon icon-picture"></i>
                        <v-btn color="primary" @click="$emit('input', USER_TYPES.COMPANY.value)"> 가입하기 </v-btn>
                    </div>
                </div> -->
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { USER_TYPES } from "@/assets/variables";

export default {
    props: {
        value: { type: String }, // userType
    },
    data: () => ({
        USER_TYPES,
    }),
};
</script>

<style>
</style>